import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const EMPTY_AGREEMENTS = [];
export const useAgreements = function useAgreements() {
    let { search, filters, refreshOnHookMount = false, withLoader = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const isVendor = useStore(selectors.user.isVendor);
    const enabled = !!businessId;
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.Agreements,
            businessId,
            isVendor,
            search,
            filters
        ],
        queryFn: ()=>api.relationship.getSummaries({
                businessId: businessId,
                type: 'agreement',
                isVendor,
                search,
                filters
            }),
        enabled,
        refreshOnHookMount,
        withLoader
    });
    return {
        agreements: data !== null && data !== void 0 ? data : EMPTY_AGREEMENTS,
        isLoading: isLoading || !enabled,
        isFetching,
        refresh,
        error
    };
};
